import {
  CREATE_GST_INVOICE_REQUEST,
  CREATE_GST_INVOICE_SUCCESS,
  CREATE_GST_INVOICE_FAIL,
  GST_INVOICE_REQUEST,
  GST_INVOICE_SUCCESS,
  GST_INVOICE_FAIL,
  FIND_GST_INVOICE_REQUEST,
  FIND_GST_INVOICE_SUCCESS,
  FIND_GST_INVOICE_FAIL,
  CLEAR_ERROR,
} from "../../constants_Phase_2/GstInvoicing/GstInvoicingConstant";

export const getGstInvoicesReducer = (state = { gstInvoices: [] }, action) => {
  switch (action.type) {
    case GST_INVOICE_REQUEST:
      return {
        ...state,
        gstInvoices: [],
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case GST_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        gstInvoices: action.payload,
        totalData: action.totalData,
        currentPage: action.currentPage,
        message: action.message,
        status: action.status,
      };

    case GST_INVOICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    default:
      return state;
  }
};

// create, get, update,delete
export const getGstInvoiceResponseReducer = (
  state = { gstInvoiceResponse: {} },
  action
) => {
  switch (action.type) {
    case CREATE_GST_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case CREATE_GST_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        gstInvoiceResponse: action.payload,
        message: action.message,
        status: action.status,
      };

    case CREATE_GST_INVOICE_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        status: action.status,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    case "EMPTY_GST_INVOICE_RESPONSE":
      return {
        ...state,
        gstInvoiceResponse: {},
      };

    default:
      return state;
  }
};

// find one
export const findGstInvoiceReducer = (state = { gstInvoice: {} }, action) => {
  switch (action.type) {
    case FIND_GST_INVOICE_REQUEST:
      return {
        gstInvoice: {},
        loading: true,
      };

    case FIND_GST_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        gstInvoice: action.payload,
      };

    case FIND_GST_INVOICE_FAIL:
      return {
        ...state,
        loading: false,
        gstInvoice: {},
        error: action.payload,
      };

    case "EMPTY_GST_INVOICE":
      return {
        gstInvoice: {},
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
      };

    default:
      return state;
  }
};
